import {
    RegisterService,
    ListarModulosdoUsuarioService,
    GetUserInforServices,
    AtualizarAsssinaturaUsuarioService,
    CadastrarFotoUsuarioService,
    RegisterAuthorizeService,
    ListarUsuariosOrganizacaoService,
} from "../../Services/Users/UsersService";

import { RegisterUserInterface } from "../../Interfaces/Users/UsersInterface";
import { Controller } from "./../Controller";

export async function RegisterController(
    grupo: RegisterUserInterface,
    idUsuarioCopia?: number
) {
    return Controller(RegisterService(grupo, idUsuarioCopia));
}

export async function RegisterAuthorizeController(
    requestBody: RegisterUserInterface,
    idOrganizacao: string,
    idUsuarioCopia?: number
) {
    return Controller(
        RegisterAuthorizeService(requestBody, idOrganizacao, idUsuarioCopia)
    );
}

export async function ListarUsuariosOrganizacaoController(grupo: boolean) {
    return Controller(ListarUsuariosOrganizacaoService(grupo));
}

export async function AtualizarAsssinaturaUsuarioController(
    requestBody: FormData,
    idUsuario?: number
) {
    return Controller(
        AtualizarAsssinaturaUsuarioService(requestBody, idUsuario)
    );
}

export async function CadastrarFotoUsuarioController(
    requestBody: FormData,
    idUsuario?: number
) {
    return Controller(CadastrarFotoUsuarioService(requestBody, idUsuario));
}

export async function ListarModulosdoUsuarioController() {
    return Controller(ListarModulosdoUsuarioService());
}

export async function GetUserInfor() {
    return Controller(GetUserInforServices());
}
